import { Routes, Route, Outlet } from 'react-router-dom';
import MainLayout from './components/layout/main-layout';
import Home from './pages/home/home';
import AboutUs from './pages/about-us';
import './index.css';
import Teleradiology from './pages/teleradiology';
import Careers from './pages/careers';
import Product from './pages/product';
import Radone from './pages/portfolio/radone';
import RadLinQ from './pages/portfolio/radlinq';
import InvoiceIQ from './pages/portfolio/invoiceiq';
import Blog from './pages/blog';
import BookADemo from './pages/book-a-demo';
import PrivacyPolicy from './pages/privacy-policy';
import TermsAndConditions from './pages/terms-and-conditions';
import NotFound from './pages/not-found';
import ScrollToTop from './components/common/scroll-to-top';

import Deployment from './pages/deployment';

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/deployment" element={<Deployment />} />
        <Route element={<MainLayout><Outlet /></MainLayout>}>
          <Route path="/" element={<Home />} />
          <Route path="/product" element={<Product />} />
          <Route path="/portfolio/radone" element={<Radone />} />
          <Route path="/portfolio/radlinq" element={<RadLinQ />} />
          <Route path="/portfolio/invoiceiq" element={<InvoiceIQ />} />
          <Route path="/teleradiology" element={<Teleradiology />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/book-a-demo" element={<BookADemo />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
